import { render, staticRenderFns } from "./DefaultHeaderDropdownNotif.vue?vue&type=template&id=3b431e96&scoped=true"
import script from "./DefaultHeaderDropdownNotif.vue?vue&type=script&lang=js"
export * from "./DefaultHeaderDropdownNotif.vue?vue&type=script&lang=js"
import style0 from "./DefaultHeaderDropdownNotif.vue?vue&type=style&index=0&id=3b431e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b431e96",
  null
  
)

export default component.exports